<script>
    export let title ='Default Title'
    export let total = 0;
</script>

<section class="main-title">
    <h2>{title}: € {total}</h2>
</section>